import React from 'react';
import { IPRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFOProps, PRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFO } from './timing-info';
import { getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import { TimingState } from '../../../../../entities/timing-state';
import { ITimingSpecComponentModel } from '../../../parser/timing-spec';
import { PRIVATE_MARKDOWN_TIMING_SECTION_SECTION_EXPANDER } from './section-expander';
import { TimingMode } from '../../../../../entities/timing-mode';

export interface IPRIVATE_MARKDOWN_TIMING_SECTION_HEADERProps extends
  IPRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFOProps {
    warningIconDescription: string;
    onClick: ((component: ITimingSpecComponentModel) => void) | undefined;
    onToggleNotesSection: ((component: ITimingSpecComponentModel) => void) | undefined;
}

const getStyleClasses = (theme: ITheme) => {

  const main: IStyle = {
    fontSize: '1.5em',
    margin: 0,
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
  };
  const mainCurrent: IStyle = {
    ...main,
    backgroundColor: theme.palette.themeLighterAlt,
  };

  const timing: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '1em',
    padding: '1em',
    paddingBottom: '0.66666666666666em',
  };

  const title: IStyle = {
    display: 'block',
    padding: '0.5em',
    fontSize: '1em',
    fontWeight: 400,
    lineHeight: '1.5em',
    flexGrow: 1,
  };

  return mergeStyleSets({
    main,
    mainCurrent,
    timing,
    title
  });
}

export const PRIVATE_MARKDOWN_TIMING_SECTION_HEADER: React.FunctionComponent<IPRIVATE_MARKDOWN_TIMING_SECTION_HEADERProps> = (props) => {
  const theme = getTheme();
  const styles = getStyleClasses(theme);

  const goodReasonToShowNotes = props.componentModel.notes.length > 0 && props.componentModel.hideNotes === false;
  const displayNotes = props.componentModel.specType === TimingMode.Preamble || goodReasonToShowNotes;

  const onNotesToggleClicked = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    !!props.onToggleNotesSection && props.onToggleNotesSection(props.componentModel);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <h1
      className={props.componentModel.timingState === TimingState.Active ? styles.mainCurrent : styles.main}
      onClick={() => !!props.onClick && props.onClick(props.componentModel)}
    >
      <div className={styles.timing}>
        {/* will not support this at this time
        <PRIVATE_MARKDOWN_TIMING_SECTION_HEADER_WARNING_BLADE
          title={props.warningIconDescription}
          displayWarning={props.componentModel.timingState === TimingState.Warning}
        />*/}
        <PRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFO
          componentModel={props.componentModel}
          firmTimingTitle={props.firmTimingTitle}
          flexTimingTitle={props.flexTimingTitle}
          shareTimingTitle={props.shareTimingTitle}
          computedTimeShareDurationDescription={props.computedTimeShareDurationDescription}
          uncomputedTimeShareDurationDescription={props.uncomputedTimeShareDurationDescription}
          firmTimeDurationDescription={props.firmTimeDurationDescription}
          flexTimeDurationDescription={props.flexTimeDurationDescription}
        />
      </div>
      <span className={styles.title} dangerouslySetInnerHTML={{ __html: props.componentModel.title }} />
      {!!props.onToggleNotesSection && props.componentModel.timingState !== TimingState.Active &&
      <PRIVATE_MARKDOWN_TIMING_SECTION_SECTION_EXPANDER
          displayNotes={displayNotes}
          onClicked={onNotesToggleClicked}
      />}
    </h1>
  );
};
